<template>
  <div id="wrapper">
    <div id="header">
      <img id="logo" :src="require('@/assets/img/logo/full_logo.png')" />
    </div>
    <div id="main-wrapper">
      <div id="main">
        <img class="login-left" :src="require('@/assets/img/login/main.png')" />
        <div class="login-right">
          <div v-show="isLogin" :style="{ width: '330px', margin: '0 auto' }">
            <div :style="{ height: '52px' }">
              <img :style="{ width: '100%', height: '100%' }" :src="require('@/assets/img/login/login_title.png')" />
            </div>
            <div class="login-type">
              <span
                style="margin-right: 80px; cursor: pointer"
                :class="{ loginActive: loginForm.loginType != 'mobile' }"
                @click="
                  loginForm.loginType = 'user'
                  loginView.error = ''
                "
              >
                账号登录
              </span>
              <span
                style="cursor: pointer"
                :class="{ loginActive: loginForm.loginType == 'mobile' }"
                @click="
                  loginForm.loginType = 'mobile'
                  loginView.error = ''
                "
              >
                短信登录
              </span>
            </div>
            <div v-show="loginForm.loginType == 'user'">
              <div v-show="!!loginView.error" class="row-block error-block">
                <i class="el-icon-warning" />
                {{ loginView.error }}
              </div>
              <div class="row-block">
                <el-input placeholder="请输入手机号" prefix-icon="el-icon-mobile-phone" v-model="loginForm.userMobile"></el-input>
              </div>
              <div class="row-block">
                <el-input
                  :type="loginView.showPassword ? 'text' : 'password'"
                  placeholder="请输入密码"
                  prefix-icon="el-icon-lock"
                  v-model="loginForm.password"
                >
                  <i
                    slot="suffix"
                    :class="[loginView.showPassword ? 'ri-eye-line' : 'ri-eye-close-line']"
                    @click="loginView.showPassword = !loginView.showPassword"
                  ></i>
                </el-input>
              </div>
            </div>
            <div v-show="loginForm.loginType == 'mobile'">
              <div v-show="!!loginView.error" class="row-block error-block">
                <i class="el-icon-warning" />
                {{ loginView.error }}
              </div>
              <div class="row-block">
                <el-input placeholder="请输入手机号" prefix-icon="el-icon-mobile-phone" v-model="loginForm.mobile"></el-input>
              </div>
              <div class="row-block">
                <el-input
                  placeholder="请输入验证码"
                  prefix-icon="el-icon-message"
                  maxlength="6"
                  oninput="value = value.replace(/[^\d]/g, '')"
                  v-model="loginForm.verifyCode"
                >
                  <span v-show="!loginView.isCountDown" slot="suffix" show-word-limit @click="getVerifyCode" style="color: #66b1ff">
                    获取验证码
                  </span>
                  <span v-show="loginView.isCountDown" slot="suffix" style="color: #66b1ff"> {{ loginView.countDown }}秒后可重新获取 </span>
                </el-input>
              </div>
            </div>
            <div class="row-block">
              <el-button type="primary" :loading="loginView.loading" @click="login">登录</el-button>
            </div>
            <div class="row-block end-block">
              <el-checkbox :style="{ float: 'left' }" @change="changeRemember" v-model="isRemember">记住密码</el-checkbox>
              <span
                @click="
                  isLogin = false
                  initRegister()
                "
              >
                注册新账号
              </span>
            </div>
          </div>
          <div v-show="!isLogin" :style="{ width: '330px', margin: '0 auto' }" class="register-block">
            <div style="height: 50px; line-height: 50px; font-size: 16px; font-weight: 600; color: #0068cd; position: relative">
              用户注册
              <span v-show="!!registerView.error" class="register-error">
                <i class="el-icon-warning-outline" />{{ registerView.error }}
              </span>
            </div>
            <div class="row-block">
              <el-input
                placeholder="请输入手机号"
                prefix-icon="el-icon-mobile-phone"
                oninput="value = value.replace(/[^\d]/g, '')"
                v-model.number="registerForm.mobile"
              ></el-input>
            </div>
            <div class="row-block">
              <el-input
                placeholder="请输入验证码"
                prefix-icon="el-icon-message"
                maxlength="6"
                oninput="value = value.replace(/[^\d]/g, '')"
                v-model="registerForm.verifyCode"
              >
                <span v-show="!registerView.isCountDown" slot="suffix" @click="getVerifyCode" style="color: #66b1ff"> 获取验证码 </span>
                <span v-show="registerView.isCountDown" slot="suffix" style="color: #66b1ff">
                  {{ registerView.countDown }}秒后可重新获取
                </span>
              </el-input>
            </div>
            <div class="row-block">
              <el-input
                :type="registerView.showPassword ? 'text' : 'password'"
                placeholder="密码至少6个字符且包含数字、字母大小写"
                prefix-icon="el-icon-lock"
                v-model="registerForm.password"
              >
                <i
                  slot="suffix"
                  :class="[registerView.showPassword ? 'ri-eye-line' : 'ri-eye-close-line']"
                  @click="registerView.showPassword = !registerView.showPassword"
                ></i>
              </el-input>
            </div>
            <div class="row-block">
              <el-input
                :type="registerView.showComfirmPassword ? 'text' : 'password'"
                placeholder="确认密码"
                prefix-icon="el-icon-lock"
                v-model="registerForm.comfirmPassword"
              >
                <i
                  slot="suffix"
                  :class="[registerView.showComfirmPassword ? 'ri-eye-line' : 'ri-eye-close-line']"
                  @click="registerView.showComfirmPassword = !registerView.showComfirmPassword"
                ></i>
              </el-input>
            </div>
            <div class="row-block">
              <el-input
                placeholder="请输入邀请码"
                prefix-icon="ri-user-add-line"
                maxlength="6"
                oninput="value = value.replace(/[^0-9a-zA-Z]/g, '')"
                v-model="registerForm.inviteCode"
              >
                <span slot="suffix" @click="getCustomerService" style="color: #66b1ff"> 添加客服微信获取 </span>
              </el-input>
            </div>
            <div class="row-block">
              <el-checkbox v-model="registerView.agree"></el-checkbox>
              已阅读并同意
              <el-link type="primary" :underline="false" @click="registerView.protocolVisible = true">
                《云果仓SaaS-ERP申请账号协议》
              </el-link>
            </div>
            <div class="row-block">
              <el-button class="submit" type="primary" :loading="registerView.loading" @click="register">注册</el-button>
            </div>
            <div class="row-block end-block">
              <span
                @click="
                  isLogin = true
                  initLogin()
                "
              >
                已有账号，去登录
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="footer-wrapper">
      <div id="footer">
        <span>Copyright ©{{ dateYear }} {{ title }} {{ domain }}</span>
        <el-divider direction="vertical" />
        <a :href="ICPLink" target="_blank"> {{ ICP }}</a>
        <el-divider direction="vertical" />
        <a :href="networkSecurityLink" target="_blank">
          <img :src="networkSecurityImg" :title="networkSecurity" />
          {{ networkSecurity }}
        </a>
      </div>
    </div>
    <el-dialog :visible.sync="verify2FAView.visible" :close-on-click-modal="false" width="350px" class="verify-2FA">
      <div><img src="/static/img/security_auth.png" /></div>
      <h2>安全验证</h2>
      <div class="tip">为了保障您的账户安全，请完成身份验证</div>
      <div v-if="verify2FAView.isSend" class="send-tip">📱 验证码已发送至 {{ maskMobile }}</div>
      <div class="verify-code">
        <el-input
          placeholder="请输入6位验证码"
          maxlength="6"
          oninput="value = value.replace(/[^\d]/g, '')"
          v-model="verify2FAForm.verifyCode"
        ></el-input>
        <el-button type="primary" :disabled="verify2FAView.isCountDown" @click="getVerifyCode">
          {{ verify2FAView.isCountDown ? verify2FAView.countDown + '秒后可重新获取' : '获取验证码' }}
        </el-button>
      </div>
      <el-button type="primary" :loading="verify2FAView.loading" @click="loginByTempToken">确认验证</el-button>
    </el-dialog>
    <el-dialog title="" :visible.sync="registerView.customerServiceVisible" width="400px" class="customer-service">
      <img :src="registerView.customerServiceImg" />
    </el-dialog>
    <el-dialog title="用户隐私和协议条款" :visible.sync="registerView.protocolVisible" width="680px">
      <div style="width: 100%; height: 300px">
        <p>
          尊敬的用户，欢迎您使用云果仓-SaaS ERP！我司云创联航科技有限公司（以下简称“云创联航”）特别提示：在使用云果仓-SaaS
          ERP之前，您应当认真阅读并遵守《云果仓-SaaS
          ERP申请账户协议》（以下简称“本协议”），请您务必审慎阅读、充分理解各条款内容，特别是免除或者限制责任的条款、争议解决和法律适用条款。如您对协议有任何疑问的，应向云创联航系统客服咨询。当您按照注册页面提示填写信息、阅读并同意本协议且完成全部注册程序后，即表示您已充分阅读、理解并接受本协议的全部内容，并与云创联航达成协议。您承诺接受并遵守本协议的约定，届时您不应以未阅读本协议的内容或者未获得云创联航对您问询的解答等理由，主张本协议无效，或要求撤销本协议。
        </p>
        <p>一、签约主体</p>
        <p>1.1、本许可协议的缔约方为云创联航和用户（“您”），本许可协议具有合同效力。</p>
        <p>二、软件许可方式</p>
        <p>
          2.1、用户和云创联航线下签订《云创联航SaaS
          ERP服务协议书》（软件许可费及许可期限以此协议书为准），如涉及线上店铺经营，用户在相应服务市场选择云创联航SaaS
          ERP版本下单购买，云创联航根据《云创联航SaaS
          ERP服务协议书》中约定的软件许可费，对服务市场购买支付金额扣除平台手续费后返款给用户。未与云创联航签订《云创联航SaaS
          ERP服务协议书》、但属于云创联航限定范围内的免费用户，则在连续12个月内自发货超2万单后需和云创联航签订《云创联航SaaS
          ERP服务协议书》。（推单给其他云创联航ERP用户发货的部分不属于自发货，具体统计口径请联系云创联航）
        </p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          @click="
            protocolVisible = false
            registerView.agree = true
          "
        >
          同意协议
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { submit } from '@/api/base'
import { doRegister } from '@/api/user'
import { domain, ICP, ICPLink, NetworkSecurityLink, NetworkSecurityImg, NetworkSecurity, noImgUrl } from '@/config'
import { checkPassword, checkMobile } from '@/utils/validate'
import { getDeviceInfo } from '@/utils/tool'

export default {
  name: 'login',
  data() {
    return {
      dateYear: new Date().getFullYear(),
      title: this.$baseTitle,
      domain: domain,
      ICP: ICP,
      ICPLink: ICPLink,
      networkSecurityLink: NetworkSecurityLink,
      networkSecurityImg: NetworkSecurityImg,
      networkSecurity: NetworkSecurity,
      isLogin: true,
      isRemember: true, //默认记住密码
      loginView: {
        showPassword: false,
        isCountDown: false,
        countDown: 60,
        error: '',
        loading: false,
      },
      verify2FAView: {
        visible: false,
        isSend: false,
        isCountDown: false,
        countDown: 60,
        loading: false,
      },
      registerView: {
        showPassword: false,
        showComfirmPassword: false,
        isCountDown: false,
        countDown: 60,
        error: '',
        customerServiceVisible: false,
        customerServiceImg: '',
        protocolVisible: false,
        agree: false,
        loading: false,
      },
      loginForm: {
        loginType: 'user',
        userMobile: '',
        password: '',
        mobile: '',
        verifyCode: '',
      },
      verify2FAForm: {
        tempToken: '',
        mobile: '',
        verifyCode: '',
      },
      registerForm: {
        mobile: '',
        verifyCode: '',
        password: '',
        comfirmPassword: '',
        inviteCode: '',
      },
    }
  },
  async beforeCreate() {
    if (this.$route.query.token && this.$route.query.redirect) {
      await this.$store.dispatch('user/setAccessToken', this.$route.query)
      this.$router.push({ name: this.$route.query.redirect }).catch(() => {})
    }
    document.querySelector('body').style =
      "background:url('/static/img/background.png') no-repeat;background-size:100% 100%;background-attachment:fixed;margin:0;"
  },
  beforeDestroy() {
    document.querySelector('body').removeAttribute('style')
  },
  async mounted() {
    if (this.$cookies.get('xbt_remember') == 'Y') {
      this.isRemember = true
      this.loginForm.userMobile = this.$cookies.get('user_mobile')
      this.loginForm.password = this.$cookies.get('user_pwd')
    }
    const deviceInfo = await getDeviceInfo()
    this.loginForm.deviceID = deviceInfo.deviceId
    this.loginForm.deviceName = deviceInfo.deviceName
    this.verify2FAForm.deviceID = deviceInfo.deviceId
    this.verify2FAForm.deviceName = deviceInfo.deviceName
    this.registerForm.deviceID = deviceInfo.deviceId
    this.registerForm.deviceName = deviceInfo.deviceName
  },
  computed: {
    maskMobile() {
      if (!this.verify2FAForm.mobile) {
        return ''
      }
      return this.verify2FAForm.mobile.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2')
    },
  },
  methods: {
    initLogin() {
      this.loginForm.loginType = 'user'
      this.loginForm.userMobile = ''
      this.loginForm.password = ''
      this.loginForm.mobile = ''
      this.loginForm.verifyCode = ''
    },
    initRegister() {
      this.registerView.agree = false
      this.registerForm.mobile = ''
      this.registerForm.verifyCode = ''
      this.registerForm.password = ''
      this.registerForm.comfirmPassword = ''
      this.registerForm.inviteCode = ''
    },
    changeRemember() {
      if (!this.isRemember) {
        this.$cookies.remove('user_mobile')
        this.$cookies.remove('user_pwd')
        this.$cookies.remove('xbt_remember')
      }
    },
    async getVerifyCode() {
      this.loginView.error = ''
      this.registerView.error = ''
      const isVerify = this.verify2FAView.visible
      const mobile = isVerify ? this.verify2FAForm.mobile : this.isLogin ? this.loginForm.mobile : this.registerForm.mobile
      if (!isVerify) {
        if (!mobile) {
          if (this.isLogin) {
            this.loginView.error = '手机号不能为空'
            return
          } else {
            this.registerView.error = '手机号不能为空'
            return
          }
        }
        if (!checkMobile(mobile)) {
          if (this.isLogin) {
            this.loginView.error = '手机号格式不正确'
            return
          } else {
            this.registerView.error = '手机号格式不正确'
            return
          }
        }
      }
      await submit('/api/user/sendVerifycode', {
        type: isVerify ? 2 : this.isLogin ? 0 : 1,
        mobile: mobile,
      })
      if (isVerify) {
        this.verify2FAForm.verifyCode = ''
        this.verify2FAView.isSend = true
        this.verify2FAView.isCountDown = true
        this.verify2FAView.countDown = 60
      } else if (this.isLogin) {
        this.loginForm.verifyCode = ''
        this.loginView.isCountDown = true
        this.loginView.countDown = 60
      } else {
        this.registerForm.verifyCode = ''
        this.registerView.isCountDown = true
        this.registerView.countDown = 60
      }
      this.countDown(isVerify, this.isLogin)
      this.$baseMessage('已发送验证码成功', 'success')
    },
    countDown(isVerify, isLogin) {
      setTimeout(() => {
        if (isVerify) {
          this.verify2FAView.countDown--
          if (this.verify2FAView.countDown > 0) {
            this.countDown(isVerify, isLogin)
          } else {
            this.verify2FAView.isCountDown = false
          }
        } else if (isLogin) {
          this.loginView.countDown--
          if (this.loginView.countDown > 0) {
            this.countDown(isVerify, isLogin)
          } else {
            this.loginView.isCountDown = false
          }
        } else {
          this.registerView.countDown--
          if (this.registerView.countDown > 0) {
            this.countDown(isVerify, isLogin)
          } else {
            this.registerView.isCountDown = false
          }
        }
      }, 1000)
    },
    async login() {
      this.loginView.error = ''
      if (this.loginForm.loginType == 'user') {
        if (!this.loginForm.userMobile) {
          this.loginView.error = '手机号不能为空'
          return
        }
        if (!checkMobile(this.loginForm.userMobile)) {
          this.loginView.error = '手机号格式不正确'
          return
        }
        if (!this.loginForm.password) {
          this.loginView.error = '密码不能为空'
          return
        }
      } else {
        if (!this.loginForm.mobile) {
          this.loginView.error = '手机号不能为空'
          return
        }
        if (!checkMobile(this.loginForm.mobile)) {
          this.loginView.error = '手机号格式不正确'
          return
        }
        if (!this.loginForm.verifyCode) {
          this.loginView.error = '验证码不能为空'
          return
        }
      }
      this.loginView.loading = true
      try {
        const res = await this.$store.dispatch('user/login', { ...this.loginForm })
        if (res?.Require2FA ?? false) {
          this.verify2FAForm.tempToken = res.TempToken
          this.verify2FAForm.mobile = res.Mobile
          this.verify2FAView.visible = true
          return
        }
        //登录成功设置cookie
        if (this.isRemember) {
          if (this.loginForm.userMobile && this.loginForm.password) {
            this.$cookies.set('user_mobile', this.loginForm.userMobile, '1y')
            this.$cookies.set('user_pwd', this.loginForm.password, '1y')
            this.$cookies.set('xbt_remember', 'Y', '1y')
          }
        } else {
          this.$cookies.remove('user_mobile')
          this.$cookies.remove('user_pwd')
          this.$cookies.remove('xbt_remember')
        }
        this.loginSuccess()
      } finally {
        this.loginView.loading = false
      }
    },
    loginSuccess() {
      let redirect = null
      if (this.$route.query.redirect) {
        redirect = this.$route.query.redirect
        if (redirect === '/404' || redirect === '/401') {
          redirect = '/'
        }
      }
      this.$router.push(redirect ? redirect : { name: this.$store.getters['user/loginRedirect'] }).catch(() => {})
    },
    async loginByTempToken() {
      if (!this.verify2FAForm.mobile) {
        this.$message.error('手机号不能为空')
        return
      }
      if (!checkMobile(this.verify2FAForm.mobile)) {
        this.$message.error('手机号格式不正确')
        return
      }
      if (!this.verify2FAForm.verifyCode) {
        this.$message.error('验证码不能为空')
        return
      }
      this.verify2FAView.loading = true
      try {
        const res = await this.$store.dispatch('user/loginByTempToken', { ...this.verify2FAForm })
        this.loginSuccess()
      } finally {
        this.verify2FAView.loading = false
      }
    },
    async getCustomerService() {
      if (!this.registerView.customerServiceImg) {
        const { data } = await submit('/api/user/getCustomerService')
        this.registerView.customerServiceImg = data && data.Url ? data.Url : noImgUrl
      }
      this.registerView.customerServiceVisible = true
    },
    async register() {
      this.registerView.error = ''
      if (!this.registerForm.mobile) {
        this.registerView.error = '手机号不能为空'
        return
      }
      if (!checkMobile(this.registerForm.mobile)) {
        this.registerView.error = '手机号格式不正确'
        return
      }
      if (!this.registerForm.verifyCode) {
        this.registerView.error = '验证码不能为空'
        return
      }
      if (!this.registerForm.password) {
        this.registerView.error = '密码不能为空'
        return
      }
      if (!checkPassword(this.registerForm.password)) {
        this.registerView.error = '密码至少6个字符且包含数字、字母大小写'
        return
      }
      if (this.registerForm.password != this.registerForm.comfirmPassword) {
        this.registerView.error = '两次密码不一样'
        return
      }
      if (!this.registerForm.inviteCode) {
        this.registerView.error = '邀请码不能为空'
        return
      }
      if (!this.registerView.agree) {
        this.registerView.error = '请先阅读协议并勾选同意'
        return
      }
      if (this.registerView.loading) {
        return
      }
      this.registerView.loading = true
      try {
        const { data } = await doRegister(this.registerForm)
        this.$baseMessage('注册成功', 'success')
        await this.$store.dispatch('user/loginSuccess', data)
        this.loginSuccess()
      } finally {
        this.registerView.loading = false
      }
    },
  },
}
</script>

<style lang="scss">
.verify-2FA {
  .el-dialog__header {
    min-height: 30px !important;
    padding-bottom: 0 !important;

    .el-icon-close {
      font-size: 20px !important;
    }

    .el-dialog__headerbtn:hover .el-dialog__close {
      color: #909399 !important;
    }
  }

  .el-dialog__body {
    display: flex;
    flex-direction: column;
    align-items: center;
    border-top: unset;
    padding: 0 20px 30px !important;

    h2 {
      margin-bottom: 6px;
    }

    .tip,
    .send-tip,
    .verify-code {
      margin-bottom: 25px;
    }

    .tip {
      font-size: 14px;
      color: #86909c;
    }

    .send-tip {
      width: 100%;
      padding: 12px 16px;
      background: #f7f8fa;
      border: 1px solid #e5e6eb;
      border-radius: 8px;
      box-sizing: border-box;
      color: #4e5969;
      font-size: 15px;
      text-align: center;
    }

    .verify-code {
      display: flex;
      flex-direction: row;

      .el-button {
        width: 150px !important;
        margin-left: 10px;
      }
    }
  }
}
</style>

<style lang="scss" scoped>
#wrapper {
  height: 100%;
  width: 100%;

  ::v-deep {
    .el-input__inner,
    .el-button {
      height: 40px !important;
      width: 100%;
      font-size: 14px;
    }

    .el-input__icon {
      font-size: 18px;
      display: inline-block;
    }

    .el-input__suffix {
      line-height: 40px;
      cursor: pointer;

      i {
        font-size: 18px;
        opacity: 0.8;
        cursor: pointer;
      }
    }

    .el-dialog__body {
      font-size: 14px;
      font-weight: 400;
      color: #000000;
      line-height: 22px;
    }

    .el-dialog__footer {
      text-align: center;

      .el-button {
        width: 300px;
      }
    }

    .el-link.el-link--default {
      color: white !important;
    }
  }

  .customer-service {
    img {
      width: 300px;
      height: 300px;
      border: 3px solid white;
    }

    ::v-deep {
      .el-dialog {
        background: none;
        box-shadow: none;

        .el-dialog__header {
          .el-icon-close::before {
            color: white;
            font-size: 30px;
            font-weight: bold;
            border: 2px solid white;
            border-radius: 30px;
          }
        }

        .el-dialog__body {
          border-top: none;
        }
      }
    }
  }
}

#header {
  height: 13%;
  min-height: 85px;
  position: relative;

  #logo {
    height: 70px;
    position: absolute;
    bottom: 0;
    left: 50px;
  }
}

#main-wrapper {
  height: 77%;
  min-height: 540px;
  position: relative;

  #main {
    width: 1200px;
    height: 440px;
    position: absolute;
    top: 50%;
    left: 50%;
    margin-top: -220px;
    margin-left: -600px;

    .login-left {
      float: left;
      width: 806px;
      height: 440px;
    }

    .login-right {
      float: left;
      height: 440px;
      width: 394px;
      background: white;
      position: relative;

      .loginActive {
        color: #0075e3;
        position: relative;

        &::after {
          content: '';
          height: 1px;
          width: 64px;
          border-bottom: 2px solid #0075e3;
          position: absolute;
          top: 22px;
          left: 0;
        }
      }

      .row-block {
        margin-bottom: 18px;
        width: 100%;

        &.end-block {
          text-align: right;
          margin-top: 28px;

          span {
            margin-left: 15px;
            cursor: pointer;
          }
        }
      }

      .register-block {
        .row-block {
          margin-bottom: 12px;
        }

        .end-block {
          margin-top: 0;
        }
      }

      .register-error {
        position: absolute;
        top: 0;
        right: 0;
        font-size: 12px;
        font-weight: 400;
        color: #ff0000;

        i {
          font-size: 14px;
          font-weight: 600;
          margin-right: 3px;
        }
      }

      .error-block {
        border: 1px solid #ff6185;
        background: #ffecf0;
        height: 40px;
        line-height: 40px;
        font-size: 14px;
        color: #f52554;
        padding: 0 5px;
        box-sizing: border-box;
        border-radius: 4px;

        i {
          font-size: 16px;
        }
      }
    }

    .login-type {
      height: 40px;
      margin: 0px auto;
      font-size: 16px;
      font-weight: 400;
      padding: 36px 0 20px 0;
      width: 240px;
    }
  }
}

#footer-wrapper {
  height: 10%;
  min-height: 40px;
  position: relative;

  #footer {
    height: 40px;
    width: 100%;
    position: absolute;
    bottom: 0;
    color: white;
    line-height: 40px;
    text-align: center;
    background: rgba(0, 0, 0, 0.08);

    a {
      color: white;

      img {
        vertical-align: middle;
        height: 20px;
        width: 20px;
      }
    }
  }
}
</style>
